var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x80\x9C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1429 15.7857H14.0714V25H4V19C4 13.5 5.28571 10.2143 7.71429 6H12.6429C11.1429 9.5 10.1429 12.2857 10.1429 15.7857ZM24.8571 15.7857H28.8571V25H18.7143V19C18.7143 13.5 20 10.2143 22.5 6H27.4286C25.8571 9.5 24.8571 12.2857 24.8571 15.7857Z",
    fill: "#E7454C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/“.8dc55351d1a8be1a35fe0a7110ee844e.svg";
export { ForwardRef as ReactComponent };